/**
 * Converts an amount from 18 decimals to a different decimal precision.
 * @param originalAmount - Amount in 18-decimal format
 * @param decidedDecimals - Target decimal precision
 * @returns Converted amount
 * @internal
 */
export function convertFromBase18(originalAmount: bigint, decidedDecimals: bigint) {
  return convert(originalAmount, 18n, decidedDecimals)
}

/**
 * Converts an amount to 18-decimal format from a different precision.
 * @param originalAmount - Amount in original decimal format
 * @param originalDecimals - Original decimal precision
 * @returns Amount converted to 18 decimals
 * @internal
 */
export function convertToBase18(originalAmount: bigint, originalDecimals: bigint) {
  return convert(originalAmount, originalDecimals, 18n)
}

/**
 * Converts a BigInt amount between different decimal precisions.
 * @param originalAmount - Amount to convert
 * @param originalDecimals - Original decimal places
 * @param decidedDecimals - Target decimal places
 * @returns Converted amount
 */
export function convert(originalAmount: bigint, originalDecimals: bigint, decidedDecimals: bigint) {
  if (originalAmount === 0n) return 0n
  if (originalDecimals === decidedDecimals) return originalAmount

  let adjustedAmount = 0n

  if (originalDecimals > decidedDecimals) {
    adjustedAmount = originalAmount / 10n ** (originalDecimals - decidedDecimals)
  } else {
    adjustedAmount = originalAmount * 10n ** (decidedDecimals - originalDecimals)
  }

  return adjustedAmount
}
